import { gql, useMutation } from '@apollo/client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FETCH_ACTION_ELIGIBILITY } from '../../../hooks/useFetchActionEligibility';
import { addAlert } from '../../../utils/alerts';
import { FETCH_EDIT_NEXT_PAYMENT_DATE_PROPERTIES } from './useEditNextPaymentDateQuery';
import { useNotificationsQuery } from '../hooks/useNotificationsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
const SUBMIT_EDIT_NEXT_PAYMENT_DATE_MUTATION = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"mutation\",\"name\":{\"kind\":\"Name\",\"value\":\"SubmitEditNextPaymentDateMutation\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"UpdateSubscriptionBillingDateInput\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"alias\":{\"kind\":\"Name\",\"value\":\"response\"},\"name\":{\"kind\":\"Name\",\"value\":\"updateSubscriptionBillingDate\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"subscriptionInvoiceId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"mutable\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"paymentDueAt\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"immediateDue\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"earliestDueAt\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"error\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "SubmitEditNextPaymentDateMutation"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "UpdateSubscriptionBillingDateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        alias: {
          kind: "Name",
          value: "response"
        },
        name: {
          kind: "Name",
          value: "updateSubscriptionBillingDate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "subscriptionInvoiceId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mutable"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "paymentDueAt"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "immediateDue"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "earliestDueAt"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "error"
            }
          }]
        }
      }]
    }
  }]
});
export function useEditNextPaymentDateMutation(handleError, onClose) {
  const {
    sendEmailForSubscriptionBillingDateChanged
  } = useNotificationsQuery();
  return useMutation(SUBMIT_EDIT_NEXT_PAYMENT_DATE_MUTATION, {
    awaitRefetchQueries: true,
    refetchQueries: [FETCH_ACTION_ELIGIBILITY, FETCH_EDIT_NEXT_PAYMENT_DATE_PROPERTIES],
    onCompleted: data => {
      var _data$response;
      if ((_data$response = data.response) !== null && _data$response !== void 0 && _data$response.error) {
        handleError();
      } else {
        addAlert({
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'subscriptions.EditNextPaymentDateModal.successfullyChangedTitle'
          }),
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: sendEmailForSubscriptionBillingDateChanged ? 'subscriptions.EditNextPaymentDateModal.successfullyChangedMessageNotify' : 'subscriptions.EditNextPaymentDateModal.successfullyChangedMessageNoNotify'
          }),
          type: 'success'
        });
        onClose();
      }
    },
    onError: () => handleError()
  });
}